export enum FilterPage {
    Contract = 1,
    System = 2,
    ProcessingActivity = 3,
    Activities = 4,
    Task = 5,
    Policy = 6,
    RiskOperationalOverview = 7,
    RiskMitigationOverview = 8,
    RiskAssessmentsOverview = 9,
    Users = 10,
    FrameworkOverview = 11,
    LegalEntityExternal = 12,
    LegalEntityGroupCompanies = 13,
    IncidentLog = 14,
    Process = 15,
    Sharing = 16,
    Frameworks = 17,
    InternalAssessments = 18,
    InternalAssessmentGroups = 19,
    PublicInternalAssessments = 20,
    LegalEntityAuditGroups = 21,
    ProcessingActivityRecord = 23,
}

export interface SessionStorageSavedView {
    page: FilterPage;
    viewId?: string;
    filterData: any;
    displayData: any;
}
